import { UserRoleEnum } from 'src/graphql/schema';

export const roleOptions = [
  {
    label: 'Owner',
    value: UserRoleEnum.Owner,
    badgeVariant: 'default' as const,
    description:
      "Manages billing, organization settings, members, and products. Automatically added to all products as a Manager.\n\nTo change your role, select 'Transfer ownership' from the table actions.",
  },
  {
    label: 'Admin',
    value: UserRoleEnum.Admin,
    badgeVariant: 'secondary' as const,
    description: 'Can manage organization members and create products.',
  },
  {
    label: 'User',
    value: UserRoleEnum.User,
    badgeVariant: 'outline' as const,
    description: "Can only access products they've been assigned to. Permissions are managed at the product level.",
  },
];

export const roleOptionsDict = roleOptions.reduce(
  (acc, role) => {
    return { ...acc, [role.value]: role };
  },
  {} as Record<UserRoleEnum, (typeof roleOptions)[0]>,
);
